import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { CheckIcon, LearnIcon, ReserveIcon } from './CustomIcons';
import styles from './Navigation.module.css';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hospitalId } = useParams();

  const prefix = hospitalId ? `/${hospitalId}` : '';

  const pathWithoutPrefix = location.pathname.replace(prefix, '') || '/';

  if (pathWithoutPrefix.startsWith('/headache/report/') || pathWithoutPrefix.startsWith('/stroke/report/')) {
    return null;
  }

  const getCurrentValue = () => {
    switch (pathWithoutPrefix) {
      case '/check':
        return 0;
      case '/learn':
        return 1;
      case '/reserve':
        return 2;
      default:
        // /hana/check/new 처럼 하위 경로일 때도 0번(Check) 활성화 유지하고 싶다면 로직 추가 가능
        if (pathWithoutPrefix.startsWith('/check')) return 0;
        if (pathWithoutPrefix.startsWith('/learn')) return 1;
        if (pathWithoutPrefix.startsWith('/reserve')) return 2;
        return 0;
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const valueToPathMap: { [key: number]: string } = {
      0: '/check',
      1: '/learn',
      2: '/reserve'
    };
    navigate(`${prefix}${valueToPathMap[newValue]}`);
  };

  return (
    <BottomNavigation
      value={getCurrentValue()}
      onChange={handleChange}
      className={styles.navigation}
      showLabels
      sx={{
        backgroundColor: 'transparent', }}
    >
      <BottomNavigationAction
        label="Check"
        icon={<CheckIcon />}
        className={`${styles.navigationItem} ${pathWithoutPrefix === '/check' ? styles.selected : ''}`}
      />
      <BottomNavigationAction
        label="Learn"
        icon={<LearnIcon />}
        className={`${styles.navigationItem} ${pathWithoutPrefix === '/learn' ? styles.selected : ''}`}
      />
      <BottomNavigationAction
        label="Reserve"
        icon={<ReserveIcon />}
        className={`${styles.navigationItem} ${pathWithoutPrefix === '/reserve' ? styles.selected : ''}`}
      />
    </BottomNavigation>
  );
};

export default Navigation; 